"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/** @type { import("../entities/types").DeliveryFeePricesUptradeWithoutTax[] } */
var deliveryFeePricesUptradeWithoutTax = [{
  maxRefNumber: 1,
  maxMeterLength: 10,
  price: 13
}, {
  maxRefNumber: 1,
  maxMeterLength: 20,
  price: 17
}, {
  maxRefNumber: 1,
  maxMeterLength: 40,
  price: 20
}, {
  maxRefNumber: 1,
  maxMeterLength: 70,
  price: 30
}, {
  maxRefNumber: 1,
  maxMeterLength: 100,
  price: 40
}, {
  maxRefNumber: 1,
  maxMeterLength: 200,
  price: 50
}, {
  maxRefNumber: 1,
  maxMeterLength: Infinity,
  price: 60
}, {
  maxRefNumber: 2,
  maxMeterLength: 10,
  price: 17
}, {
  maxRefNumber: 2,
  maxMeterLength: 20,
  price: 20
}, {
  maxRefNumber: 2,
  maxMeterLength: 40,
  price: 25
}, {
  maxRefNumber: 2,
  maxMeterLength: 70,
  price: 35
}, {
  maxRefNumber: 2,
  maxMeterLength: 100,
  price: 45
}, {
  maxRefNumber: 2,
  maxMeterLength: 200,
  price: 55
}, {
  maxRefNumber: 2,
  maxMeterLength: Infinity,
  price: 65
}, {
  maxRefNumber: 3,
  maxMeterLength: 10,
  price: 20
}, {
  maxRefNumber: 3,
  maxMeterLength: 20,
  price: 25
}, {
  maxRefNumber: 3,
  maxMeterLength: 40,
  price: 30
}, {
  maxRefNumber: 3,
  maxMeterLength: 70,
  price: 40
}, {
  maxRefNumber: 3,
  maxMeterLength: 100,
  price: 55
}, {
  maxRefNumber: 3,
  maxMeterLength: 200,
  price: 60
}, {
  maxRefNumber: 3,
  maxMeterLength: Infinity,
  price: 70
}, {
  maxRefNumber: 4,
  maxMeterLength: 10,
  price: 22
}, {
  maxRefNumber: 4,
  maxMeterLength: 20,
  price: 30
}, {
  maxRefNumber: 4,
  maxMeterLength: 40,
  price: 35
}, {
  maxRefNumber: 4,
  maxMeterLength: 70,
  price: 45
}, {
  maxRefNumber: 4,
  maxMeterLength: 100,
  price: 60
}, {
  maxRefNumber: 4,
  maxMeterLength: 200,
  price: 70
}, {
  maxRefNumber: 4,
  maxMeterLength: Infinity,
  price: 80
}, {
  maxRefNumber: 5,
  maxMeterLength: 10,
  price: 30
}, {
  maxRefNumber: 5,
  maxMeterLength: 20,
  price: 35
}, {
  maxRefNumber: 5,
  maxMeterLength: 40,
  price: 40
}, {
  maxRefNumber: 5,
  maxMeterLength: 70,
  price: 50
}, {
  maxRefNumber: 5,
  maxMeterLength: 100,
  price: 70
}, {
  maxRefNumber: 5,
  maxMeterLength: 200,
  price: 75
}, {
  maxRefNumber: 5,
  maxMeterLength: Infinity,
  price: 90
}, {
  maxRefNumber: 9,
  maxMeterLength: 10,
  price: 30
}, {
  maxRefNumber: 9,
  maxMeterLength: 20,
  price: 40
}, {
  maxRefNumber: 9,
  maxMeterLength: 40,
  price: 50
}, {
  maxRefNumber: 9,
  maxMeterLength: 70,
  price: 60
}, {
  maxRefNumber: 9,
  maxMeterLength: 100,
  price: 75
}, {
  maxRefNumber: 9,
  maxMeterLength: 200,
  price: 80
}, {
  maxRefNumber: 9,
  maxMeterLength: Infinity,
  price: 110
}, {
  maxRefNumber: Infinity,
  maxMeterLength: 10,
  price: 30
}, {
  maxRefNumber: Infinity,
  maxMeterLength: 20,
  price: 40
}, {
  maxRefNumber: Infinity,
  maxMeterLength: 40,
  price: 50
}, {
  maxRefNumber: Infinity,
  maxMeterLength: 70,
  price: 70
}, {
  maxRefNumber: Infinity,
  maxMeterLength: 100,
  price: 90
}, {
  maxRefNumber: Infinity,
  maxMeterLength: 200,
  price: 110
}, {
  maxRefNumber: Infinity,
  maxMeterLength: Infinity,
  price: 150
}];
var _default = exports["default"] = deliveryFeePricesUptradeWithoutTax;